import {
  monthDayForDateKey,
  weekdayLongForDateKey,
} from '../../../shared/time/labels.js';
import { HeaderClock } from './HeaderClock.jsx';

/**
 * Weekday, date and clock, stacked at the right of the header.
 *
 * The weekday and date are derived from the Eastern date key, so they change only
 * when the Eastern calendar date changes, not once a second with the clock.
 *
 * @param {{dateKey: string}} props  A `YYYY-MM-DD` Eastern calendar date.
 */
export function HeaderDateStack({ dateKey }) {
  return (
    <div className="header-date">
      <p className="lab header-date__weekday">{weekdayLongForDateKey(dateKey)}</p>
      <p className="num header-date__day">{monthDayForDateKey(dateKey)}</p>
      <HeaderClock />
    </div>
  );
}
